import { Note } from '../_service/data.service';

function formatSizeValue(value: number): string {
  return Number.isInteger(value) ? `${value}` : value.toFixed(1).replace(/\.0$/, '');
}

/** `wholeBelowMb`: sizes under 1 MB without decimals ("13 KB", not "12.7 KB") — the Home List's Size column. */
export function formatPersistedNoteSize(sizeBytes: number | null | undefined, options: { wholeBelowMb?: boolean } = {}): string {
  if (!Number.isFinite(sizeBytes) || sizeBytes == null || sizeBytes < 0) {
    return 'Not available';
  }

  const bytes = Number(sizeBytes);
  if (bytes < 1024) {
    return `${bytes} bytes`;
  }

  if (bytes < 1024 * 1024) {
    return options.wholeBelowMb ? `${Math.round(bytes / 1024)} KB` : `${formatSizeValue(bytes / 1024)} KB`;
  }

  return `${formatSizeValue(bytes / (1024 * 1024))} MB`;
}

export function calculateNoteRecordSizeBytes(note: Partial<Note> | null | undefined): number {
  if (!note) {
    return 0;
  }

  const serialized = JSON.stringify(note) ?? '';
  return new TextEncoder().encode(serialized).length;
}

export function formatNoteRecordSize(note: Partial<Note> | null | undefined): string {
  const bytes = calculateNoteRecordSizeBytes(note);

  if (bytes < 1024) {
    return `${bytes} bytes`;
  }

  if (bytes < 1024 * 1024) {
    return `${formatSizeValue(bytes / 1024)} KB`;
  }

  return `${formatSizeValue(bytes / (1024 * 1024))} MB`;
}